import { isFeatureEnabled } from "utils/helpers";

export const FABRIC_EDITOR = "v2";
export const POLOTNO_EDITOR = "v3";
export const DESIGN_STUDIO_V2_EDITOR_ENABLED = isFeatureEnabled(
  "ENABLE_DESIGN_STUDIO_V2_EDITOR",
);
